import { Roles } from '@/utils/roles';
import { FeaturesEnum } from '@utils/features';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';
import { MonitoringDailyReportPage } from '../elements';

const ROOT = 'monitoring';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    guard: [Roles.ADMIN, Roles.ATM],
    title: ROOT,
    feature: FeaturesEnum.MONITORS,
    onlyOption: true,
  },
  daily: {
    path: pathJoin(root, [ROOT, 'daily']),
    element: MonitoringDailyReportPage,
    params: undefined,
    title: 'daily',
    show: true,
    feature: FeaturesEnum.MONITORS_DAILY,
  },
});

export const pathMonitoring = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
